<template>
  <v-row justify="center">
    <v-card outlined raised>
      <div v-show="showessentials">
        <v-chip
          :color="getColor(currentStatus)"
          :class="`d-flex justify-space-around mb-4`"
          >{{ currentStatus }}</v-chip
        >
        <div :class="`d-flex justify-center`">
          <v-btn text>{{ nameAndMid }}</v-btn>
        </div>
        <v-form v-model="isValid">
          <v-textarea
            v-model="comment"
            :counter="255"
            outlined
            prepend-inner-icon="mdi-comment-text"
            placeholder="Message.."
            hint="Optional message"
            dense
            auto-grove
            height="100"
            no-resize
          ></v-textarea>
          <div v-if="!loggedIn">
            <v-text-field
              v-model="ac"
              outlined
              required
              prepend-inner-icon="mdi-lock-question"
              placeholder="Access code"
              :rules="acRules"
              hint="Your access code"
              :append-icon="eyevalue ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="() => (eyevalue = !eyevalue)"
              :type="eyevalue ? 'password' : 'text'"
            ></v-text-field>
          </div>
          <v-row>
            <v-col></v-col>
            <!-- <v-col>
              <v-btn
                :disabled="!isValid"
                color="primary"
                @click="getAcValid"
                hint="Check valid access code"
                :class="`d-flex justify-space-around mb-6`"
              >Test AC</v-btn>
            </v-col> -->
            <v-col>
              <v-btn
                :disabled="!isValid"
                color="primary"
                @click="submit"
                :class="`d-flex justify-space-around mb-6`"
                >Submit</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="lightgrey"
                link
                :to="cancellink.to"
                :class="`d-flex justify-space-around mb-6`"
                >{{ cancelBtnText }}</v-btn
              >
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-alert type="success" :value="isAlertVisible">{{
            statusResultMsg
          }}</v-alert>
          <v-alert type="error" :value="isWarningAlertVisible">{{
            statusResultMsg
          }}</v-alert>
        </v-form>
        <ul v-if="errors && errors.length">
          <li v-for="error of errors" :key="error.id" style="color: Red">
            {{ error.message }}
          </li>
        </ul>
      </div>
      <div v-show="!showessentials">
        <v-alert type="error">Sorry. You can not refresh this page.</v-alert>
        <v-row>
          <v-col></v-col>
          <v-col>
            <v-btn
              link
              :to="cancellink.to"
              :class="`d-flex justify-space-around mb-6`"
              >OK</v-btn
            >
          </v-col>
          <v-col></v-col>
        </v-row>
      </div>
    </v-card>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "SaveMsgForm",
  //   props: {
  //     pid: Number
  //   },
  data() {
    return {
      pid: 0,
      // nextStatusId: null,
      // nextStatus: "",
      currentStatus: null,
      currentStatusId: null,
      name: null,
      mid: null,
      nameAndMid: null,
      comment: "",
      ac: null,
      eyevalue: true,
      eventId: null,
      showessentials: true,
      cancelBtnText: "Cancel",
      // headers: [
      //   // { text: "Id", value: "RegId" },
      //   // { text: "Mobile", value: "MID" },
      //   // { text: "Name", value: "Name" },
      //   // { text: "Current status", value: "Status" },
      //   // { text: "Select txt", value: "SelectTxt" },
      //   { text: "Select next status", value: "NextStatus" }
      // ],
      statuses: [],
      errors: [],
      statusResult: Number,
      statusResultMsg: String,
      cancellink: { to: "/airbox/0" },
      isValid: true,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      acRules: [(v) => !!v || "Access code is required"],
      loggedIn: false,
      cookieRegId: Number,
      cookieToken: Number,
      //   msgRules: [v => (v.length > 0 && v.length < 10) || "Sorry. Max number of characters is 255."]
    };
  },

  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    // this.pid = 0;
    this.pid = this.$route.params.id;
    if (this.pid === undefined) {
      this.pid = 0;
      this.showessentials = false;
    }
    this.mid = null;
    this.name = null;
    this.nameAndMid = null;
    this.nextStatus = "";
    this.comment = "";
    this.getCookies();
    this.getstatus();
  },
  methods: {
    submit() {
      var regId = this.pid;
      var statusId = this.currentStatusId;
      var eventId = this.eventId;
      var ac = this.ac;
      var comment = this.comment;
      if (comment === null) {
        comment = "";
      }
      var toSubmit = JSON.stringify({ statusId, eventId, ac, comment });
      const uri = this.baseUrl + "setstatus/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 1);
    },

    getAcValid() {
      var regId = this.pid;
      var ac = this.ac;
      var toSubmit = JSON.stringify({ ac });
      const uri = this.baseUrl + "getacvalid/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 1);
    },
    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
            this.statusToken = response.data.Token;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
            this.statusToken = response.data[0].Token;
          }
          if (this.statusResult == 1) {
            this.getstatus();
            this.cancelBtnText = "Done";
            this.isValid = false;
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    getColor(Status) {
      if (Status === "START") return "red";
      else if (Status === "LANDED") return "orange";
      else return "green";
    },

    // newStatus(nextStatus, nextStatusId, id) {
    //   console.log(nextStatusId);
    //   this.nextStatus = nextStatus;
    //   this.nextStatusId = nextStatusId;
    //   var array = this.statuses;
    //   array.forEach(element => {
    //     element.outlined = false;
    //   });
    //   this.statuses[id - 1].outlined = true;
    // },
    // clear() {
    //   this.comment = "Hm";
    //   console.log(this.comment);
    // },

    getstatus() {
      axios
        // .get("http://jsonplaceholder.typicode.com/posts")
        // .get('http://localhost:3000/pilotlist')
        .get(this.baseUrl + "/nextstatus/" + this.pid)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.statuses = response.data;
          this.name = response.data[0].Name;
          this.mid = response.data[0].MID;
          this.nameAndMid =
            response.data[0].Name + " (" + response.data[0].MID + ")";
          this.nextStatusId = response.data[0].StatusId;
          this.currentStatusId = response.data[0].StatusId;
          this.currentStatus = response.data[0].Status;
          this.nextStatus = this.currentStatus;
          this.eventId = response.data[0].EventId;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    }
  }
};
</script>